import { Feature, Polygon as GeoJSONPolygon, MultiPolygon, Point, Position } from "geojson";
import { GroupedGeoJSON } from "../../../../../../utilities/types";
import { COLORS, MAX_FEATURES, ProcessedFeatureData } from "./GeoPreviewMap.types";

export function getFeatureColor(index: number): string {
	return COLORS[index % COLORS.length];
}

export interface PolygonElementParams {
	key: string;
	path: google.maps.LatLngLiteral[];
	color: string;
	properties: Record<string, unknown>;
}

export interface PointElementParams {
	key: string;
	position: google.maps.LatLngLiteral;
	color: string;
	properties: Record<string, unknown>;
}

export function processFeatures(inputData: GroupedGeoJSON[], groupIndex: number): ProcessedFeatureData {
	const polygons: PolygonElementParams[] = [];
	const points: PointElementParams[] = [];
	const coords: google.maps.LatLngLiteral[] = [];
	let featureCount = 0;

	inputData.forEach((geoData, dataIndex) => {
		const features = geoData.geoJSON.features || [];

		features.forEach((feature, featureIndex) => {
			if (featureCount >= MAX_FEATURES) return;

			const geometry = feature.geometry;
			if (!geometry) return;

			featureCount++;
			const featureKey = `${groupIndex}-${dataIndex}-${featureIndex}`;
			const color = getFeatureColor(dataIndex);

			if (geometry.type === "Polygon" || geometry.type === "MultiPolygon") {
				const polygonFeature = feature as Feature<GeoJSONPolygon | MultiPolygon>;
				const coordinates =
					geometry.type === "Polygon" ? [polygonFeature.geometry.coordinates] : polygonFeature.geometry.coordinates;

				// Process each polygon (for MultiPolygon, this iterates over each polygon)
				const paths = coordinates.map((coordinate) => {
					return coordinate
						.map((ring) => {
							return (ring as Position[])
								.map((cc) => {
									const latLng = { lat: cc[1], lng: cc[0] };
									coords.push(latLng);
									return latLng;
								})
								.flat();
						})
						.flat();
				});

				paths.forEach((path, pathIndex) => {
					polygons.push({
						key: `polygon-${featureKey}-${pathIndex}`,
						path,
						color,
						properties: feature.properties || {},
					});
				});
			} else if (geometry.type === "Point") {
				const pointFeature = feature as Feature<Point>;
				const position = {
					lat: pointFeature.geometry.coordinates[1],
					lng: pointFeature.geometry.coordinates[0],
				};
				coords.push(position);

				points.push({
					key: `point-${featureKey}`,
					position,
					color,
					properties: feature.properties || {},
				});
			}
		});
	});

	return {
		polygonData: polygons,
		pointData: points,
		totalFeatures: featureCount,
		allCoordinates: coords,
	};
}
